import { render, staticRenderFns } from "./ModattaAboutHero.vue?vue&type=template&id=036c49d5"
import script from "./ModattaAboutHero.vue?vue&type=script&lang=js"
export * from "./ModattaAboutHero.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports